__turbopack_context__.v({
  "CloseButton": "Modal-module-scss-module__1Kigfa__CloseButton",
  "Description": "Modal-module-scss-module__1Kigfa__Description",
  "Footer": "Modal-module-scss-module__1Kigfa__Footer",
  "Header": "Modal-module-scss-module__1Kigfa__Header",
  "HeaderText": "Modal-module-scss-module__1Kigfa__HeaderText",
  "MiddleSection": "Modal-module-scss-module__1Kigfa__MiddleSection",
  "Modal": "Modal-module-scss-module__1Kigfa__Modal",
  "ScrollArea": "Modal-module-scss-module__1Kigfa__ScrollArea",
  "Title": "Modal-module-scss-module__1Kigfa__Title",
  "padding-disabled": "Modal-module-scss-module__1Kigfa__padding-disabled",
  "scroll-disabled": "Modal-module-scss-module__1Kigfa__scroll-disabled",
});
